//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import DynamicFormFields from '~/components/form/DynamicFormFields.vue';
import BaseButton from '~/components/BaseButton.vue';
import CommonService from '~/services/Common';
import processError from '~/helpers/processError';
import createFormData from '@/helpers/createFormData';

export default {
    components: { BaseButton, DynamicFormFields },
    props: {
        formId: { type: [Number, String], default: '' }
    },
    data() {
        return {
            form: null,
            formData: {},
            errors: {},
            isFormSending: false,
            isFormPending: false
        };
    },
    fetch() {
        return Promise.all([
            this.fetchForm()
        ]);
    },
    computed: {
        isBusy() {
            return this.isFormSending || this.isFormPending;
        },
        templateData() {
            const form = this.form?.form;

            return {
                formTitle: form?.formTitle || form?.title || '',
                formSubtitle: '',
                actionTitle: form?.buttonText || 'Отправить'
            };
        },
        fields() {
            const fields = this.form?.fields;

            return (Array.isArray(fields) ? fields : []).map((field) => {
                field.classes = 'col-span-2';

                return field;
            });
        },
        normalizedFormData() {
            const data = {};

            Object.keys(this.formData).forEach((key) => {
                const value = this.formData[key];
                if (typeof value === 'object' && value) {
                    data[key] = value.id;
                } else {
                    data[key] = value;
                }
            });

            return data;
        }
    },
    methods: {
        async fetchForm() {
            if (!this.formId) {
                return;
            }

            this.isFormPending = true;
            try {
                const result = await CommonService.fetchFormData(this.formId);
                if (result) {
                    this.form = result;
                }
            } catch (e) {
                processError(e);
            }
            this.isFormPending = false;
        },
        resetErrors() {
            this.errors = {};
        },
        async submit() {
            this.resetErrors();
            this.isFormSending = true;

            try {
                const result = await CommonService.postFormData(this.formId, createFormData(this.normalizedFormData));

                if (result) {
                    const successText = result.successText || 'Данные отправлены';

                    this.$layer.alert({
                        title: 'Отправлено',
                        message: successText,
                        buttonCaption: 'Спасибо',
                        withButton: true,
                        icon: {
                            name: 'stars'
                        }
                    });
                    this.onSuccess();
                }
            } catch (error) {
                if (error) {
                    processError(error, this.errors);
                }
            }


            this.isFormSending = false;
        },
        clearForm() {
            this.formData = {};
        },
        onSuccess() {
            this.$emit('success');
            this.clearForm();
        },
        onSubmit() {
            this.submit();
        }
    }
};

